import { toRaw } from 'vue'

/**
 * Recursively converts a deeply nested object or array into a raw version by replacing Vue reactive properties with their raw values.
 * @param {any} value - The value to convert to a raw object.
 * @return {any} The raw version of the input value.
 */
export function deepToRaw(value: any): any {
	// Check if the value is an object (including arrays)
	if (value && typeof value === 'object') {
		if (Array.isArray(value)) {
			// Map each element of the array to its raw version using deepToRaw recursively
			return value.map((item) => deepToRaw(item))

			// If the value is an object (but not an array)
		} else {
			// Create a new raw object
			const rawObj: { [key: string]: any } = {}

			// Iterate over each key in the object
			for (const key in value) {
				// Convert each property to its raw version using toRaw and deepToRaw recursively
				rawObj[key] = deepToRaw(toRaw(value[key]))
			}
			return rawObj
		}
	}
	// If the value is not an object or array, return it as-is
	return value
}
